import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import TextField from 'src/components/TextField';
import { RoleType } from 'src/types/role';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './index';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: RoleType;
    editErrors: FormErrorsType;
    newRole: boolean;
    disableEdit: boolean;
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={4}>
                <TextField
                    value={props.editData.ROLE_NAME}
                    error={props.editErrors.ROLE_NAME}
                    onChange={(value, error) => props.onChange('ROLE_NAME', value, error)}
                    name="ROLE_NAME"
                    label={translate('roleDetail.name')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={4}>
                <TextField
                    value={props.editData.ROLE_INFO}
                    error={props.editErrors.ROLE_INFO}
                    onChange={(value, error) => props.onChange('ROLE_INFO', value, error)}
                    name="ROLE_INFO"
                    label={translate('roleDetail.info')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
